/**
 * Shared display formatters for the Session Leaders rationale surfaces
 * (MED-1009 / E4.0e). Used by both the refined Schedule drawer and the
 * Participants subpage so the same value always renders identically.
 */

/** Format a -2..+2 average with an explicit sign; `—` when missing. */
export function formatScore(value: number | null): string {
  if (value === null || Number.isNaN(value)) return '—';
  const rounded = Math.round(value * 100) / 100;
  // Up to 2 decimals, trailing zeros trimmed but at least one decimal kept.
  let body = rounded.toFixed(2).replace(/0+$/, '');
  if (body.endsWith('.')) body += '0';
  const sign = rounded > 0 ? '+' : '';
  return `${sign}${body}`;
}

/** Render a list of session numbers as a compact, sorted `S1, S5` string. */
export function compactSessions(sessionNumbers: number[]): string {
  return sessionNumbers
    .slice()
    .sort((a, b) => a - b)
    .map(n => `S${n}`)
    .join(', ');
}
